import React, { useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import StyledProps from './theme/AppThemeInterface';

const DEFAULT_X_OFFSET_PX = 0;
const DEFAULT_Y_OFFSET_PX = 22;

export interface TooltipProps {
  children: any;
  text: string | React.ReactNode;
  tooltipMaxWidthPx?: number;
  xOffsetPx?: number;
  yOffsetPx?: number;
}

export interface TooltipState {
  hovering: boolean;
}

interface StyledTooltipProps extends StyledProps {
  xOffset: number;
  yOffset: number;
  maxWidth?: number;
}

export const StyledTooltip = styled.div`
  z-index: ${({ theme }: StyledTooltipProps) => theme.tooltipZIndex};
  position: absolute;
  font-size: 12px;
  font-weight: bolder;
  white-space: normal;
  line-height: 16px;
  color: white;
  font-family: ${({ theme }: StyledProps) => theme.appFontFamily};
  ${({ maxWidth, xOffset, yOffset }: StyledTooltipProps) => css`
    left: ${xOffset !== undefined && xOffset !== null ? xOffset : DEFAULT_X_OFFSET_PX}px;
    top: ${yOffset !== undefined && yOffset !== null ? yOffset : DEFAULT_Y_OFFSET_PX}px;
    width: ${maxWidth ? maxWidth + 'px' : null};
    word-break: break-word;
    text-align: center;
  `};
`;

export const StyledTooltipContent = styled.div`
  background-color: ${({ theme }: StyledTooltipProps) => theme.tooltipBackgroundColor};
  z-index: ${({ theme }: StyledTooltipProps) => theme.tooltipZIndex};
  padding: 4px 10px;
  position: absolute;
  font-size: 12px;
  font-weight: 500;
  border-radius: 4px;
  float: left;
`;
const StyledTooltipContainer = styled.div`
  position: relative;
`;
const Tooltip = (props: TooltipProps) => {
  const { children, text, tooltipMaxWidthPx, xOffsetPx, yOffsetPx } = props;

  const element = useRef<HTMLDivElement>(null);
  const [hovering, setHovering] = useState<boolean>(false);

  const handleMouseEnter = () => {
    setHovering(true);
  };

  const handleMouseLeave = () => {
    setHovering(false);
  };

  return (
    <StyledTooltipContainer>
      <div ref={element} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        {children}
      </div>
      <React.Fragment>
        {hovering && (
          <StyledTooltip maxWidth={tooltipMaxWidthPx} xOffset={xOffsetPx} yOffset={yOffsetPx}>
            <StyledTooltipContent>{text}</StyledTooltipContent>
          </StyledTooltip>
        )}
      </React.Fragment>
    </StyledTooltipContainer>
  );
};

export default Tooltip;
